import { configureStore } from "@reduxjs/toolkit";
import { authAPI, authAPIReducer } from "../api/rtk/auth/authApi";
import { baseAPI, baseAPIReducer } from "../api/rtk/base/baseApi";
import { geocoderAPI, geocoderAPIReducer } from "../api/rtk/geocoder/geocoderApi";
import { gismeteoAPI, gismeteoAPIReducer } from "../api/rtk/gismeteo/gismeteoApi";
import { mapWFSAPI, mapWFSAPIReducer } from "../api/rtk/mapWFS/mapWFSApi";
import { rosreestrAPI, rosreestrAPIReducer } from "../api/rtk/rosreestr/rosreestrApi";
import { authReducer } from "../features/auth";
import { mapsMiddleware } from "./middleware/maps";
import { configReducer, contentHeaderReducer, customMapReducer, customObjectDocumentsReducer, diagnosticsReducer, diagnosticsRoadMeasureResultsReducer, documentsReducer, favouritesReducer, loginReducer, mapFiltersReducer, mapInfoReducer, mapReducer, mapSettingsReducer, mapTooltipReducer, panoramaReducer, pathNormativitiesReducer, pathsInfoReducer, roadAccidentSegmentsReducer, roadAccidentsReducer, roadBedLayerSegmentsReducer, roadCategorySegmentsReducer, roadDiagnosticsSegmentsReducer, roadWebCameraReducer, rosreestrReducer, sidebarReducer, tableObjectReducer, tableReducer, toastMessageReducer, transportHistoryReducer, transportNowReducer, transportObjectInfoReducer, weatherReducer } from "./reducers";
import { customAuthReducer } from "./reducers/custom/CustomAuthSlice";
import { roadMeasuresReducer } from "./reducers/diagnostics/RoadMeasuresSlice";
import { mapsReducer } from "./reducers/maps";
import { objectsOnMapPointInfoReducer } from "./reducers/ObjectsOnMapPointInfoSlice";
import { tableButtonsRowReducer } from "./reducers/TableButtonsRowSlice";
import { weatherStationsAPI, weatherStationsAPIReducer } from "../api/rtk/weatherStations/weatherStationsApi";

export const store = configureStore({
    reducer: {
        baseAPI: baseAPIReducer,
        rosreestrAPI: rosreestrAPIReducer,
        gismeteoAPI: gismeteoAPIReducer,
        weatherStationsAPI: weatherStationsAPIReducer,
        mapWFSAPI: mapWFSAPIReducer,
        authAPI: authAPIReducer,
        geocoderAPI: geocoderAPIReducer,
        auth: authReducer,
        pathsInfo: pathsInfoReducer,
        config: configReducer,
        table: tableReducer,
        tableObject: tableObjectReducer,
        map: mapReducer,
        panorama: panoramaReducer,
        favourites: favouritesReducer,
        documents: documentsReducer,
        diagnostics: diagnosticsReducer,
        roadDiagnosticsSegments: roadDiagnosticsSegmentsReducer,
        roadMeasures: roadMeasuresReducer,
        diagnosticsRoadMeasureResults: diagnosticsRoadMeasureResultsReducer,
        diagnosticsPathNormativities: pathNormativitiesReducer,
        sidebar: sidebarReducer,
        mapTooltip: mapTooltipReducer,
        roadBedLayerSegments: roadBedLayerSegmentsReducer,
        roadCategorySegments: roadCategorySegmentsReducer,
        mapInfo: mapInfoReducer,
        transportNow: transportNowReducer,
        transportHistory: transportHistoryReducer,
        transportObjectInfo: transportObjectInfoReducer,
        roadAccidents: roadAccidentsReducer,
        roadAccidentSegments: roadAccidentSegmentsReducer,
        roadWebCamera: roadWebCameraReducer,
        weather: weatherReducer,
        customAuth: customAuthReducer,
        customMap: customMapReducer,
        customObjectDocuments: customObjectDocumentsReducer,
        mapFilters: mapFiltersReducer,
        contentHeader: contentHeaderReducer,
        mapSettings: mapSettingsReducer,
        objectsOnMapPointInfo: objectsOnMapPointInfoReducer,
        rosreestr: rosreestrReducer,
        maps: mapsReducer,
        login: loginReducer,
        toastMessage: toastMessageReducer,
        tableButtonsRow: tableButtonsRowReducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat([
        baseAPI.middleware, rosreestrAPI.middleware, mapWFSAPI.middleware,
        geocoderAPI.middleware, authAPI.middleware, gismeteoAPI.middleware],
        mapsMiddleware, weatherStationsAPI.middleware),
    devTools: true
})

export type RootState = ReturnType<typeof store.getState>
export type AppStore = ReturnType<typeof configureStore>
export type AppDispatch = typeof store.dispatch
